/**
 * Helpers internos para construir tuples readonly de query keys.
 *
 * Hand-rolled, zero dependências (alinhado com QW-2 e o padrão do monorepo).
 * Não dependemos de bibliotecas tipo `@lukemorales/query-key-factory` para
 * evitar mais uma dep externa e manter o output 100% transparente
 * (cada key é literalmente um array com `as const`).
 *
 * Exemplo de uso interno (em `sales.ts`):
 *
 *   const root = ["sales"] as const;
 *   const leads = tuple(root, "leads");          // readonly ["sales", "leads"]
 *   const list = tuple(leads, "list", orgId);    // readonly ["sales", "leads", "list", string]
 */

/**
 * Combina parts em um tuple readonly. Aceita `undefined` para args opcionais
 * (filtros, ids parciais) — que vão para a key como-é, garantindo que
 * `useQuery({ queryKey: qk.foo.list(undefined) })` continue distinto de
 * `qk.foo.list("abc")`.
 */
export function tuple<T extends readonly unknown[], U extends readonly unknown[]>(
  base: T,
  ...rest: U
): readonly [...T, ...U] {
  return [...base, ...rest] as const;
}
